import React, { useCallback, useEffect, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import {
    generateClinicQrCanvas,
    safeQrFileName,
} from '../utils/generateClinicQr';

interface QrWithClinicLabelProps {
    value: string;
    gameName: string;
    clinicName: string;
    previewSize?: number;
}

const QrWithClinicLabel: React.FC<QrWithClinicLabelProps> = ({
    value,
    gameName,
    clinicName,
    previewSize = 46,
}) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    const drawQrCard = useCallback(async () => {
        const generatedCanvas = await generateClinicQrCanvas({
            value,
            gameName,
            clinicName,
        });

        const targetCanvas = canvasRef.current;

        if (!targetCanvas) {
            return;
        }

        targetCanvas.width = generatedCanvas.width;
        targetCanvas.height = generatedCanvas.height;

        const context = targetCanvas.getContext('2d');

        if (!context) {
            return;
        }

        context.clearRect(
            0,
            0,
            targetCanvas.width,
            targetCanvas.height
        );

        context.drawImage(generatedCanvas, 0, 0);
    }, [value, gameName, clinicName]);

    useEffect(() => {
        drawQrCard();
    }, [drawQrCard]);

    const downloadQrCode = async () => {
        const canvas = await generateClinicQrCanvas({
            value,
            gameName,
            clinicName,
        });

        const link = document.createElement('a');

        link.download =
            `${safeQrFileName(gameName)}_` +
            `${safeQrFileName(clinicName)}_QRCode.png`;

        link.href = canvas.toDataURL('image/png', 1);
        link.click();
    };

    return (
        <div
            className="kpi-qr-cell"
            onClick={downloadQrCode}
            title={`Download QR for ${clinicName}`}
        >
            <QRCodeCanvas
                value={value}
                size={previewSize}
                level="M"
            />

            <canvas
                ref={canvasRef}
                style={{ display: 'none' }}
            />
        </div>
    );
};

export default QrWithClinicLabel;